export default __webpack_public_path__ + "static/media/logo_useconcept_200.afb0c075.png";